import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import queueTask from 'post-task';
import { getPublicUser } from '@sbt-web/auth';
import { initDidomi } from '@sbt-web/didomi';
import type { AdItem } from '@sbt-web/network/types';
import { DataLayerBridge } from '@/client/bridges/DataLayer';
import { markPerformance, Marks } from '@/client/utilities/performance/performanceMonitor';
import { initPresencePing } from '@/client/utilities/presence-ping';
import { sendViewClassifiedAdEvent } from '@/tools/tracking/AdViewTracking';
import { getOrCreatePulse } from '@/tools/tracking/utils';
type Params = {
  ad: AdItem;
  trustPingEnabled?: boolean;
};
const useAdDetailCommons = t0 => {
  const $ = _c(5);
  const {
    ad,
    trustPingEnabled
  } = t0;
  let t1;
  let t2;
  if ($[0] !== ad || $[1] !== trustPingEnabled) {
    t1 = () => {
      markPerformance(Marks.AD_DETAILS_USE_EFFECT);
      new DataLayerBridge("adview", ad).register(getPublicUser());
      queueTask(_temp, "background");
      if (trustPingEnabled) {
        queueTask(_temp2, "user-visible");
      }
    };
    t2 = [ad, trustPingEnabled];
    $[0] = ad;
    $[1] = trustPingEnabled;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp3, t3);
};
export { useAdDetailCommons };
function _temp() {
  sendViewClassifiedAdEvent();
}
function _temp2() {
  initPresencePing();
}
function _temp3() {
  initDidomi(getOrCreatePulse(), "addetail");
}